<template>
	<div>
		<b-form-group>
			<div v-for="(alternative, index) in alternatives" v-bind:key="index">
				<b-row>
					<b-col cols="1">
						<b-form-radio
							:name="fieldInfo.name + 'Radio'"
							v-model="selectedIndex"
							:value="index"
							class="mt-2"
							@change="radioChange(index)"
							:disabled="!active"
						></b-form-radio>
					</b-col>
					<b-col cols="10">
						<b-form-input
							type="text"
							:size="fieldInfo.size"
							:state="state"
							v-model="alternative.description"
							:name="fieldInfo.name"
							@change="fieldChange(index, alternative.description)"
							:readonly="!active"
							:key="active"
						></b-form-input>
					</b-col>
				</b-row>
			</div>
		</b-form-group>

		<b-form-invalid-feedback :id="`${fieldInfo.name}-feedback`">
			{{ errors[fieldInfo.name] }}
		</b-form-invalid-feedback>
	</div>
</template>

<script>
export default {
	props: {
		fieldInfo: {
			type: Object
		},
		state: {
			type: Boolean,
			default: null
		},
		alternatives: {
			type: Array,
			required: true
		},
		errors: {
			type: Object
		},
		isActive: {
			type: [Boolean, Function],
			required: true
		}
	},
	data() {
		return {
			active: false
		};
	},
	computed: {
		selectedIndex: {
			get() {
				return this.alternatives.findIndex((alternative) => alternative.isDefault);
			},
			set(newValue) {
				this.$emit("change", this.fieldInfo.name);
				this.$emit("input", newValue);
			}
		}
	},
	methods: {
		addNewOption: function () {
			this.alternatives.push({ description: "", isDefault: false });
		},
		deleteOption: function (index) {
			this.alternatives.splice(index, 1);
		},
		radioChange: function (index) {
			this.alternatives.forEach((alternative) => (alternative.isDefault = false));
			this.alternatives[index].isDefault = true;
		},
		fieldChange: function (index, newValue) {
			this.alternatives[index].description = newValue;
			this.$emit("change", this.fieldInfo.name);
			//this.$emit("input", this.value);
		},
		parentChanged: function (parentValue) {
			if (typeof this.isActive == "function") {
				this.active = this.isActive(parentValue);
				if (this.value) {
					// TODO @rafael.silva achar um hack melhor pra fazer isso
					this.alternatives.push("");
					this.alternatives.pop();
				}
			}
		}
	},
	beforeMount() {
		if (typeof this.isActive == "function") {
			this.active = this.isActive(null);
		} else {
			this.active = this.isActive;
		}
	}
};
</script>
